import React, { useRef, useEffect, useState } from 'react';

import { parseDateDesktop, parseDateDesktopMonth, parseEntities, today } from '../../utils/helpers';
import { FilterIcon, CloseIcon } from './../../../eagerlyIcons/src/__generated__/icons';

const FilterBarDesktop = ({
  activeFilterDate,
  activeTimestamp,
  activeCinema,
  activeTags,
  sortingDecision,
  availableDates,
  availableDatesMonths,
  availableCinema,
  availableTags,
  currentConfig,
  showFilters,
  handleToggle,
  handleFilter,
  rootElement,
}) => {
  const ref = useRef(),
    [isSticky, setIsSticky] = useState(false),
    [rootMargin, setRootMargin] = useState(0);

  const closeFilterDropdowns = (e) => {
    if (!e.target.classList.contains('custom-select') && e.target.closest('.custom-select') == null) {
      rootElement.removeEventListener('mousedown', closeFilterDropdowns);
      rootElement.querySelectorAll('.js_react_filter .custom-select__trigger').forEach((element) => {
        element.setAttribute('aria-expanded', 'false');
      });
    }
  };

  const toggleSelectList = (e) => {
    if (e.target.tagName.toLowerCase() === 'li' || e.target.tagName.toLowerCase() === 'ul') {
      return;
    }
    rootElement.removeEventListener('mousedown', closeFilterDropdowns);
    rootElement.addEventListener('mousedown', closeFilterDropdowns);
    rootElement.querySelectorAll('.js_react_filter .custom-select__trigger').forEach((element) => {
      if (e.currentTarget.contains(element)) {
        element.setAttribute('aria-expanded', element.getAttribute('aria-expanded') == 'true' ? 'false' : 'true');
      } else {
        element.setAttribute('aria-expanded', 'false');
      }
    });
  };

  const buttonLabelCinema = () => {
    if (activeCinema.length === 0) return `${customData.i18n.agenda_filter_choose} ${customData.i18n.agenda_cinema_name}`; //kies bioscoop
    if (activeCinema.length === availableCinema.length) return customData.i18n.agenda_cinema_all; //Alle bioscopen
    return activeCinema.join(', ');
  };

  const buttonLabelTags = () => {
    if (activeTags.length === 0) return `${customData.i18n.agenda_filter_choose} ${customData.i18n.agenda_tag_filter_name}`; //kies filter
    if (activeTags.length === availableTags.length) return customData.i18n.agenda_tag_filter_all; //alle filters
    if (activeTags.length === 1) return parseEntities(activeTags[0]);
    return `${activeTags.length} ${customData.i18n.agenda_tag_filter_selected}`;
  };

  const getPosition = (filterOption) => {
    if (showFilters[0] === filterOption && showFilters[showFilters.length - 1] === filterOption) {
      return 'first last';
    } else if (showFilters[0] === filterOption) {
      return 'first';
    } else if (showFilters[showFilters.length - 1] === filterOption) {
      return 'last';
    }
  };

  return (
    <div className="agenda__top-nav">
      <h2>Agenda</h2>

      {activeFilterDate && (
        <button onClick={() => handleFilter('filterDate', 'all')} className="btn btn--reset">
          {parseDateDesktopMonth(activeTimestamp)}
          <CloseIcon />
        </button>
      )}

      {showFilters.includes('date') && (
        <div className={`custom-select ${getPosition('date')}`} onClick={(e) => toggleSelectList(e)}>
          <button className="custom-select__trigger has-selected js-date-button " aria-haspopup="listbox" aria-labelledby="date_label date_button" aria-expanded="false" id="date_button">
            <div className="custom-select__label btn" id="date_label">
              <span className="sr-only">`${customData.i18n.agenda_filter_choose} `</span>
              Filter <FilterIcon />
            </div>
          </button>
          <ul className="listbox" role="listbox" aria-labelledby="date_label" aria-activedescendant="date_000">
            {availableDatesMonths.map((date, index) => (
              <li
                onClick={() => handleFilter('filterDate', date)}
                role="option"
                className={date === activeTimestamp ? activeFilterDate && 'has-focus' : ''}
                id="date_000"
                aria-selected={date === activeTimestamp ? activeFilterDate && 'true' : 'false'}
                data-value={date}
                key={index}
              >
                {parseDateDesktopMonth(date)}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default FilterBarDesktop;
